// utils/buildTableData.js
export default function buildTableData(columns = [], list = []) {
  const cols = Array.isArray(columns) ? columns : [];
  const rows = Array.isArray(list) ? list : [];

  return rows
    .filter(Boolean)
    .map((item) => {
      const row = {};
      cols.forEach((column) => {
        if (!column || column.csvOff) return;

        const label = column.title ?? column.dataIndex ?? "";

        if (column.renderCsv && typeof column.renderCsv === "function") {
          row[label] = column.dataIndex
            ? column.renderCsv(item?.[column.dataIndex], item)
            : column.renderCsv(item);
        } else {
          row[label] = column.dataIndex ? item?.[column.dataIndex] : item;
        }
      });
      return row;
    });
}
